import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Trash2, AlertTriangle, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { NeuButton } from "../../components/neu/Neu";
import { avatarGlobalEstimate, avatarResetAll } from "../../api/platform";

// زر خطير لمالك المنصّة: تصفير كل الأفاتار لكل الشركات بعد تأكيد يعرض الكلفة التقديرية.
export const AvatarGlobalReset = ({ onDone }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [est, setEst] = useState(null);
  const [busy, setBusy] = useState(false);

  const openConfirm = async () => {
    setOpen(true); setEst(null);
    try { setEst(await avatarGlobalEstimate()); } catch { toast.error(t("errors.generic")); }
  };

  const confirm = async () => {
    setBusy(true);
    try {
      const r = await avatarResetAll();
      toast.success(t("platform.avatarsPanel.doneGlobal", { n: r.reset }));
      setOpen(false); onDone?.();
    } catch { toast.error(t("errors.generic")); }
    finally { setBusy(false); }
  };

  return (
    <>
      <NeuButton onClick={openConfirm} className="flex items-center gap-2 px-4 py-2.5 text-sm text-destructive" data-testid="avatar-reset-global">
        <Trash2 className="h-4 w-4" /> {t("platform.avatarsPanel.resetAllGlobal")}
      </NeuButton>

      {open ? (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4" data-testid="avatar-global-confirm"
          onClick={() => !busy && setOpen(false)}>
          <div className="grid w-full max-w-md gap-4 rounded-[28px] bg-background p-6 shadow-neu" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center gap-3 text-destructive">
              <AlertTriangle className="h-6 w-6 shrink-0" />
              <h3 className="text-lg font-black">{t("platform.avatarsPanel.confirmGlobalTitle")}</h3>
            </div>
            {est ? (
              <p className="text-sm leading-7 text-muted-foreground" data-testid="avatar-global-body">
                {t("platform.avatarsPanel.confirmGlobalBody", { companies: est.companies, avatars: est.with_avatar, cost: est.estimated_cost })}
              </p>
            ) : <Loader2 className="mx-auto h-6 w-6 animate-spin text-primary" />}
            <div className="flex justify-end gap-2">
              <NeuButton onClick={() => setOpen(false)} disabled={busy} className="px-4 py-2.5 text-sm" data-testid="avatar-global-cancel">
                {t("platform.avatarsPanel.cancel")}
              </NeuButton>
              <NeuButton variant="primary" onClick={confirm} disabled={busy || !est} className="flex items-center gap-2 px-4 py-2.5 text-sm" data-testid="avatar-global-proceed">
                {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : null}
                {t("platform.avatarsPanel.proceed")}
              </NeuButton>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};
